export const LOCAL_STORAGE_AVATARS_KEY = '@doris:avatars'
